import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
const tableHead = [
  "Sr.",
  "Name / Phone No",
  "Department",
  "Interview Date",
  "Job Type / Emp Type",
  "Assigned Interviewer",
  "Actions",
];

const CandidateDetailstable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/view-candidate-details/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>
                  <span className="border-bottom pb-1">
                    {item.Fname || "N/A"}
                  </span>
                  <div className="pt-1">
                    {item?.phoneNo && (
                      <span>
                        <b>{item?.phoneNo}</b>
                      </span>
                    )}
                  </div>
                </td>

                <td>{item?.departments || "N/A"}</td>
                <td>{item?.interviewScheduleDate || "N/A"}</td>
                <td>
                  <span className="border-bottom pb-1">
                    {item.jobType || "N/A"}
                  </span>
                  <div className="pt-1">
                    {item?.Etype && (
                      <span>
                        <b>{item?.Etype}</b>
                      </span>
                    )}
                  </div>
                </td>
                <td>{item?.assignedInterviewer || "N/A"}</td>

                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CandidateDetailstable;
